import React from 'react'
import styled from '@emotion/styled'

import { convertToReadableDate, sortMethods } from 'Helpers'

import GridRow from 'Components/Grid/GridRow'
import Report from 'Components/Report'

const GridRowAlert = styled(GridRow)`
  &:nth-of-type(2n) > * {
    ${({ critical }) => critical && 'background: #e01b1b;'}
    ${({ warning }) => warning && 'background: #444;'}
  }
  &:nth-of-type(2n + 1) > * {
    ${({ critical }) => critical && 'background: #c21717;'}
    ${({ warning }) => warning && 'background: #333;'}
  }
`

const AlertRow = ({ row: alert }) => (
  <>
    <GridRowAlert>
      <div>{alert.patientRef}</div>
      <div>{alert.group}</div>
      <div>{alert.responseDate}</div>
      <div>{alert.physician}</div>
      <div>{alert.tCode}</div>
      <div>{alert.journey}</div>
      <div>{alert.question}</div>
      <div>{alert.answer}</div>
      <div
        style={{
          color: ['', '#f00', '#ff9500'][
            ['Critical', 'Warning'].indexOf(alert.alertLevel) + 1
          ],
          fontWeight: ['Critical', 'Warning'].includes(alert.alertLevel)
            ? 'bold'
            : ''
        }}
      >
        {alert.alertLevel}
      </div>
    </GridRowAlert>
  </>
)

const columns = [
  { header: 'Patient', property: 'patientRef' },
  { header: 'Group', property: 'group', sort: sortMethods.group },
  {
    header: 'Response Date',
    property: 'responseDate',
    format: convertToReadableDate,
    sort: sortMethods.date,
    size: '1.2x'
  },
  { header: 'Physician', property: 'physician' },
  { header: 'T-Code', property: 'tCode' },
  { header: 'Journey', property: 'journey', size: '2x' },
  { header: 'Question', property: 'question', size: '2x' },
  { header: 'Answer', property: 'answer' },
  {
    header: 'Alert',
    property: 'alertLevel',
    sort: sortMethods.alert,
    size: '0.8x'
  }
]

export default ({ report }) => (
  <Report
    id={'alert'}
    report={report}
    columns={columns}
    ReportRow={AlertRow}
    defaultSortIndex={8}
    prop="alerts"
  />
)
